var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch-components"},[_c('ul',{staticClass:"component-list"},[_vm._l((_vm.componentList),function(item,index){return [(!item.hidden)?_c('li',{key:index,staticClass:"component-item-wrap",class:{
          'active-item-wrap':
            _vm.activeComponent === item.component ||
            (item.children && item.children.includes(_vm.activeComponent))
        },on:{"click":function($event){return _vm.handleChange(item.component)}}},[_c('div',{staticClass:"component-item"},[_vm._v(_vm._s(_vm.$t(item.title)))])]):_vm._e()]})],2),_c('div',{staticClass:"handles-wrap"},[_vm._t("handles")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }